import { useEffect, useState } from 'react';

import { KeycloakProfile } from 'keycloak-js';

import { useKeycloak } from '@react-keycloak/web';

export const useAuth = () => {
  const { keycloak, initialized } = useKeycloak();
  const isAuthenticated = keycloak.authenticated;

  // Roles are not stored in the user profile for some reason so we access it from the JWT
  const roles = keycloak?.tokenParsed?.realm_access?.roles;

  // But we need some profile information. The proper way is to async access it from the instance.
  const [profile, setProfile] = useState<null | KeycloakProfile>(null);
  useEffect(() => {
    const get = async () => {
      if (keycloak.authenticated) {
        setProfile(await keycloak.loadUserProfile());
      }
    };
    get();
  }, [keycloak]);

  return { isAuthenticated, keycloak, initialized, roles, profile };
};

export default useAuth;
